<template>
  <aha-modal
    width="400px"
    :title="title"
    :no-margin-padding="true"
    :visible-overflow="true"
    v-if="presentation "
    @hide="$emit('hide')"
  >
    <div class="divider" />
    <div class="p-5 pt-4">
      <p class="mb-4">
        {{ $i18nPresenter.t('Please choose which version you would like to download') }}
      </p>

      <aha-radio

        class="p-2  border-item mb-2"
        :class="{'font-bold': !isDownloadLastVersion}"
        name="isDownloadLastVersion"
        :value="false"
        v-model="isDownloadLastVersion"
      >
        {{ $i18nPresenter.t('Previous version (Generated on {x})', {
          x: moment(timeExport).format('DD/MM/YYYY HH:mm'),
        }) }}
      </aha-radio>

      <aha-radio
        class="p-2  border-item"
        :class="{'font-bold': isDownloadLastVersion}"
        name="isDownloadLastVersion"
        :value="true"
        v-model="isDownloadLastVersion"
      >
        {{ $i18nPresenter.t('Download latest version') }}
      </aha-radio>
    </div>
    <div class="flex justify-end gap-2 mt-3 p-5 ">
      <aha-button @click="handleDownloadFile">
        {{ $i18nPresenter.t("Download") }}
      </aha-button>
      <aha-button :variant="'base'" @click="$emit('hide')">
        {{ $i18nPresenter.t("Cancel") }}
      </aha-button>
    </div>
  </aha-modal>
</template>
<script>
import moment from 'moment'
import utils from '@/util'

export default {
  props: {
    presentation: {
      type: Object,
      default: () => {},
    },
    exportType: {
      type: String,
      default: 'pdf',
    },

  },
  data() {
    return {
      title: this.$i18nPresenter.t('Select version'),
      isDownloadLastVersion: false,
    }
  },
  computed: {
    moment() {
      return moment
    },
    timeExport() {
      return this.exportData.requestAt
    },
    exportData() {
      return this.presentation.exportData
    },
    linkFileDownload() {
      if (!this.exportData) return null
      const mappingExportType = {
        image: 'zipUrl',
        pdf: 'pdfUrl',
      }
      return this.exportData[mappingExportType[this.exportType]]
    },

  },
  destroyed() {
    this.isDownloadLastVersion = false
  },
  methods: {
    handleDownloadFile() {
      if (this.isDownloadLastVersion) {
        this.$emit('downloadLastVersion', this.exportType)
        this.$emit('hide')
        return
      }
      if (this.linkFileDownload) {
        utils.downloadFile(this.linkFileDownload)
      }

      this.$emit('hide')
    },

  },
}

</script>
<style  lang="scss" scoped >
.title-modal-version{
  color: #282E3E;
  font-weight: 700;
  font-size: 16px;
}
.modal-close{
  svg{
    cursor: pointer;
  }
}
p{
  color : #282E3E;
}
.border-item{
  border: 1px solid #D3D7E1;
  border-radius: 4px;
}
.divider{
  height: 1px;
  background-color:#EBEBEB;

}

</style>
